<template>
  <div class="cabecalho-origem">
    <div class="cabecalho-origem-item" v-for="(valor, rotulo) in dados" :key="rotulo">
      <span class="cabecalho-origem-rotulo">{{ rotulo }}</span>
      <span class="cabecalho-origem-valor">{{ valor }}</span>
    </div>
  </div>
</template>

<script>
/**
 * Renderização padrão do cabeçalho da origem: pares rótulo/valor em duas colunas.
 *
 * Não há ícone por campo de propósito: os rótulos são definidos por quem alimenta a
 * API (podem ser quaisquer), então não há como escolher um ícone coerente aqui. Quem
 * precisar de layout próprio usa o slot `#cabecalho` do <checklist>.
 */
export default {
  name: 'CabecalhoOrigem',

  props: {
    // { 'Placa': 'ABC1234', 'Motorista': 'João', ... } - na ordem recebida
    dados: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
  .cabecalho-origem {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px 24px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    padding: 12px 16px;
  }

  .cabecalho-origem-item {
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  /* Sem linha embaixo dos dois últimos itens de cada coluna. Como o número de campos
     é definido por quem integra (pode ser ímpar), usamos os seletores de última linha
     em vez de contar itens. */
  .cabecalho-origem-item:last-child,
  .cabecalho-origem-item:nth-last-child(2):nth-child(odd) {
    border-bottom: none;
  }

  .cabecalho-origem-rotulo {
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.6);
    text-transform: capitalize;
  }

  .cabecalho-origem-valor {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    overflow-wrap: break-word;
  }

  @media (max-width: 600px) {
    .cabecalho-origem {
      grid-template-columns: minmax(0, 1fr);
      gap: 0;
    }

    /* Em coluna única a regra de "penúltimo ímpar" não vale - só o último fica sem linha. */
    .cabecalho-origem-item:nth-last-child(2):nth-child(odd) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }

    .cabecalho-origem-item:last-child {
      border-bottom: none;
    }
  }
</style>
